import { render, staticRenderFns } from "./pmgPhoneInput.vue?vue&type=template&id=40b6346b"
import script from "./pmgPhoneInput.vue?vue&type=script&lang=js"
export * from "./pmgPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports